<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div> 
      </div>

      <div class="modal__main-icon modal__main-icon--setting"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addRoleModal.${"title"}`) }}</div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <div class="add__content">
              <div class="form__field">
                <div class="user__select" v-if="$checkRolePermission('team_access')">
                  <VSelect class="select select--default" :options="teams" :reduce="(team) => team.id" label="name"
                   :placeholder="$t(`addRoleModal.${'selectTeam'}`)" :class="{ 'input--error': selectedTeamHasError }"
                    v-model="selectedTeam" />
                </div>
                <div class="form__error" v-if="selectedTeamHasError">
                  {{ $t(`addRoleModal.${"teamErrorMsg"}`) }}
                </div>
              </div>
              <div class="form__field role-name-field">
                <input type="text" class="input input--default" :class="{ 'input--error': roleNameHasError }"
                  :placeholder="$t(`addRoleModal.${'rolePlaceholder'}`)" v-model="roleName" />
                <div class="form__error" v-if="roleNameHasError">
                  {{ $t(`addRoleModal.${"roleErrorMsg"}`) }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <button v-if="$checkRolePermission('role_create')"
          class="modal__button modal__button--submit button button--default" @click="addRole()">
          <span>{{ $t(`addRoleModal.${"addRoleBtn"}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
 
defineOptions({
  name: "AddRoleModal"
});

const store = useStore();
 
const { proxy } = getCurrentInstance();
 
const roleName = ref("");
const roleNameHasError = ref(false);
const isRequesting = ref(false);
const selectedTeam = ref("");
const selectedTeamHasError = ref(false);
 
const teams = computed(() => store.getters.teams);
 
watch(roleName, (newValue) => {
  roleNameHasError.value = !newValue;
});

watch(selectedTeam, (newValue) => {
  selectedTeamHasError.value = !newValue;
});
 
const closeModal = () => {
  store.commit("setShowAddRoleModal", false);
};

const getTeams = async () => {
  await store.dispatch("getTeams");
};

const addRole = async () => {
  isRequesting.value = true;
  if (roleName.value && selectedTeam.value) {
    await store.dispatch("createRole", {
      title: roleName.value,
      team_id: selectedTeam.value
    });

    store.commit("setRoles", []);
    store.commit("setTeams", []);
    store.commit("setPermissions", []);
    await store.dispatch("getTeams");

    closeModal();
  } else {
    if (roleName.value === "" || roleName.value === null) {
      roleNameHasError.value = true;
    }
    if (selectedTeam.value === "" || selectedTeam.value === null) {
      selectedTeamHasError.value = true;
    }
  }
  isRequesting.value = false;
};
 
onMounted(() => {
  if (proxy && !proxy.$checkRolePermission('role_create')) {
    closeModal();
  } else {
    getTeams();
  }
});
</script>

<style scoped lang="scss">
.form__field {
  margin-top: 80px;
}

.modal__button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 200px;
}

.role-name-field {
  margin-top: 30px;
}
</style>
